import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as jsPDF from 'jspdf';
import * as moment from 'moment';
import { autoTable } from 'jspdf-autotable';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

export class FileDownloader {
  constructor() { }

  static exportAsExcelFile(json, excelFileName) {
    const worksheet = XLSX.utils.json_to_sheet(json);
    const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  static saveAsExcelFile(buffer, fileName) {
    const data = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  }

  static downloadAsPdf(columns, rows, fileName, columnStyles) {
    const doc = new jsPDF('p', 'pt');
    doc.autoTable(columns, rows, {
      styles: {
        overflow: 'linebreak',
        cellWidth: 'wrap',
      },
      columnStyles: columnStyles
    });
    doc.save(fileName);
  }

  static prepExcelDownload(itemList, selectedItems, fileName, timeAttr) {
    const camEvents = [];
    let index = 1;

    for (const item of itemList) {
      const e = {};

      e['No.'] = index;
      for (const sItem of selectedItems) {
        if (sItem === timeAttr) {
          e[sItem] = moment(item[sItem]).format('YYYY-DD-MM HH:mm:ss:SSS');
        } else if (sItem === 'tags') {
          if(item.tags) {
            const tagKs = Object.keys(item.tags)
            e[sItem] = null
            for(const tagK of tagKs) {
              if(!e[sItem]) {
                e[sItem] = tagK + ' : ' + item.tags[tagK]
              } else {
                e[sItem] = e[sItem] + ', '  + tagK + ' : ' + item.tags[tagK]
              }
            }
          } else {
            e[sItem] = ''
          }
        } else {
          e[sItem] = item[sItem];
        }
      }

      camEvents.push(e);

      index++;
    }

    this.exportAsExcelFile(camEvents, fileName);
  }

  static prepPdfDownload(itemList, selectedItems, fileName, columnStyles) {
    const columns = [];

    columns.push({ title: 'No.' });
    for (const sItem of selectedItems) {
      columns.push({ title: sItem });
    }

    const rows = [];
    let tempRow = [];
    let index = 1;

    for (const item of itemList) {

      tempRow = [index];

      for (const sItem of selectedItems) {
        if (sItem === 'tags') {
          let tagStr = null
          if(item.tags) {
            const tagKs = Object.keys(item.tags)
            for(const tagK of tagKs) {
              if(!tagStr) {
                tagStr = tagK + ' : ' + item.tags[tagK]
              } else {
                tagStr = tagStr + ', '  + tagK + ' : ' + item.tags[tagK]
              }
            }
          } else {
            tagStr = ''
          }
          tempRow.push(tagStr);
        } else {
          tempRow.push(item[sItem]);
        }
      }

      rows.push(tempRow);
      index++;
    }

    this.downloadAsPdf(columns, rows, fileName, columnStyles);
  }
}


// WEBPACK FOOTER //
// ./src/common/helpers/FileDownloader.js